module.exports = __webpack_public_path__ + "img/ICON_app-click_green.6938528d.png";